import { render } from "./InplayMain.vue?vue&type=template&id=40ad0ffa&scoped=true"
import script from "./InplayMain.vue?vue&type=script&lang=js"
export * from "./InplayMain.vue?vue&type=script&lang=js"

import "./InplayMain.vue?vue&type=style&index=0&id=40ad0ffa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad0ffa"]])

export default __exports__